import { useTransactionDetailsDialog } from '@utils/dialogs-hooks';
import {
  TransactionCountryFlag,
  TransactionCardNumber,
} from './TransactionBankCell';
import { TransactionChargedAmount } from './TransactionChargedCell';
import {
  TransactionOrderId,
  TransactionCreatedAt,
} from './TransactionDetailsCell';
import { TransactionStatus } from './TransactionStatusCell';

export default function TransactionMobile({ row }) {
  const { openTransactionDetailsDialog } = useTransactionDetailsDialog();
  return (
    <div
      className="tableMobile__list-item"
      onClick={() => openTransactionDetailsDialog(row)}
    >
      <div className="transactionBankCell transactionMobile">
        <div>
          <div className="transactionBankCell__icon">
            <TransactionCountryFlag row={row} />
            <TransactionCardNumber row={row} />
          </div>
          <TransactionOrderId row={row} />
        </div>
        <div className="transactionMobile__right">
          <TransactionChargedAmount row={row} />
          <TransactionCreatedAt row={row} />
          <TransactionStatus row={row} />
        </div>
      </div>
    </div>
  );
}
